import React, { useState } from 'react'
// import { Link } from 'react-router-dom'
import { Box, Flex, Text, List, Collapse, Divider } from '@chakra-ui/react'
import { ProgressBarWrapper } from '../../../app/components/ProgressBar'
// import ViewIcon from '../../../assets/icons/StackIcon'
import { calculatePercentage } from '../../../utils/helpers'
import ArrowUpIcon from '../../../assets/icons/ArrowUp'
import ArrowDownIcon from '../../../assets/icons/ArrowDownIcon'
import { AnalysisDevice } from '../../analysis/api/types'
import { DashboardDevice } from '../types'
import { CELSIUM, KILOWATT_HOUR } from '../../../utils/consts'

function getDeviceParameter(type: string, device: AnalysisDevice) {
  if (type === 'generator') {
    return device.total_generated_power
  } else if (type === 'consumers') {
    return device.total_consumption
  }else if (type === 'temperature') {
    return device.avg_temperature
  }
  return 0
} 

const DeviceItem = ({ device, type, totalConsumption, locationId, level = 0 }) => {
  const [showChildren, setShowChildren] = useState(device.is_main)
  const [showAllChildren, setShowAllChildren] = useState(false)
  const maxVisibleChildren = 5

  const toggleChildren = () => {
    if (device.children?.length > 0) {
      setShowChildren(!showChildren)
    }
  }

  const handleShowMore = () => {
    setShowAllChildren(!showAllChildren)
  }

  const alwaysVisibleItems = device.children.slice(0, maxVisibleChildren)
  const additionalItems = device.children.slice(maxVisibleChildren)

  return (
    <Box>
      <Flex
        align="center"
        gap="4"
        py="5"
        _hover={device.children?.length > 0 && { bg: '#f7f9fd' }}
        px="15px"
        cursor={device.children?.length > 0 && 'pointer'}
        position="relative"
        onClick={toggleChildren}
        style={{
          marginLeft: `${level}px`,
        }}
      >
        {level > 0 && (
          <Divider
            borderWidth="thin"
            orientation="vertical"
            position="absolute"
            left="-2px"
          />
        )}

        <ProgressBarWrapper
          title={device.title}
          variant={type === 'generator' ? 'generator' : 'consumer'}
          kilowatts={
             getDeviceParameter(type, device)
          }
          percentage={calculatePercentage(
            getDeviceParameter(type, device),
            totalConsumption,
          )}
          measurementUnit={type === 'temperature' ? CELSIUM : KILOWATT_HOUR}
        />
        {device.children?.length > 0 ? (
          showChildren ? (
            <ArrowUpIcon />
          ) : (
              <ArrowDownIcon />
            )
        ) : null}
        {/* <Link
          to={`/deviceInfo?device=${device.id}&location=${locationId}`}
          onClick={(e) => e.stopPropagation()}
        >
          <ViewIcon />
        </Link> */}
      </Flex>
      {device.children?.length > 0 && (
        <Collapse in={showChildren} animateOpacity>
          <Box pl="6">
            {alwaysVisibleItems.map((child) => (
              <DeviceItem
                key={child.id}
                device={child}
                type={type}
                totalConsumption={totalConsumption}
                locationId={locationId}
                level={level + 1}
              />
            ))}
            <Collapse in={showAllChildren} animateOpacity>
              {additionalItems.map((child) => (
                <DeviceItem
                  key={child.id}
                  device={child}
                  type={type}
                  totalConsumption={totalConsumption}
                  locationId={locationId}
                  level={level + 1}
                />
              ))}
            </Collapse>
            {device.children.length > maxVisibleChildren && (
              <Flex justifyContent="space-around">
                <Text onClick={handleShowMore} cursor="pointer" variant="ghost">
                  {showAllChildren
                    ? `See less ${type === 'generator' ? 'generators' : 'consumers'}`
                    : `See all ${type === 'generator' ? 'generators' : 'consumers'}`}
                  {showAllChildren ? <ArrowUpIcon /> : <ArrowDownIcon />}
                </Text>
              </Flex>
            )}
          </Box>
        </Collapse>
      )}
    </Box>
  )
}

type DevicesContainerProps = {
  devices: AnalysisDevice | DashboardDevice,
  totalConsumption: number,
  title: string,
  type: string,
  locationId: string | number
}

const DevicesContainer = ({ devices, totalConsumption, title, type, locationId }: DevicesContainerProps) => {
  return (
    <Box py="16px" transition={{ height: '200ms' }}>
      <Text px="15px" fontSize="14px" fontWeight="700" color="text.secondary">
        {title}
      </Text>
      <List overflow="hidden">
        <DeviceItem
          key={devices.id}
          device={devices}
          type={type}
          totalConsumption={totalConsumption}
          locationId={locationId}
        />
      </List>
    </Box>
  )
}

export default DevicesContainer
